import { Tabs, Tab, ButtonGroup, ToggleButton } from 'react-bootstrap';
import DefaultLayout from '../../../components/Layouts/DefaultLayout';
import Filter from '../components/Filter';
import { Box } from '@mui/system';
import DataTable from '../components/DataTable';
import '../styles.css';
import { useHistory } from 'react-router-dom';

const ComprehensiveIncomeScreen = ({
  tableData,
  params,
  onFilter,
  onExport,
}) => {
  const history = useHistory();

  let data_ = tableData.data.filter(
    (rows) => rows.account_name !== 'Contribution Margin',
  );
  return (
    <DefaultLayout title="Comprehensive Income">
      {/* <Box sx={{ float: 'right', width: '277px', marginTop: '-80px' }}>
        <ButtonGroup className="w-100">
          <ToggleButton
            size="sm"
            key={`radio-1-1`}
            id={`radio-1-1`}
            type="radio"
            variant="outline-success"
            onChange={() =>
              history.push('/finance-and-accounting/income-statement')
            }
          >
            Report View
          </ToggleButton>
          <ToggleButton
            size="sm"
            key={`radio-1-0`}
            id={`radio-1-0`}
            type="radio"
            variant="success"
            disabled
          >
            Table View
          </ToggleButton>
        </ButtonGroup>
      </Box> */}
      <Tabs id="controlled-tab-example" className="default-tab">
        <Tab
          className="default-tab-content"
          eventKey="comprehensive_income"
          title="Comprehensive income"
        >
          <Box className="mb-3">
            <Filter onFilter={onFilter} onExport={onExport} />
          </Box>
          {console.log('tableData.data', tableData.data)}
          {console.log('tableData.data', data_)}
          <DataTable
            data={data_}
            isLoading={tableData.loading}
            headers={tableData.headers}
            dateFields={tableData.dateFields}
            params={params}
          />
        </Tab>
      </Tabs>
    </DefaultLayout>
  );
};

export default ComprehensiveIncomeScreen;
